<template>

    <div class="app-container" v-if="canList">
        <div class="filter-container">
<!--            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"-->
<!--                      placeholder="活动ID"-->
<!--                      v-model="listQuery.entity.lotteryAct.name">-->
<!--            </el-input>-->
<!--            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"-->
<!--                      placeholder="奖品名称"-->
<!--                      v-model="listQuery.entity.lotteryGoods.name">-->
<!--            </el-input>-->

            <el-select @change='handleFilter' clearable class="filter-item input" style="width: 130px"
                       v-model="listQuery.entity.lotteryGoods.status"
                       placeholder="启用">
                <el-option v-for="(item,index) in  statusOptions" :key="item" :label="item" :value="index">
                </el-option>
            </el-select>

            <div style="display: inline-block">

                <el-button style="margin-left: 10px;" class="filter-item" type="primary" v-waves icon="el-icon-search"
                           @click="handleFilter">查找
                </el-button>
                <el-button class="filter-item" style="margin-left: 10px;" @click="handleCreate" type="primary"
                           v-if="canSave" icon="el-icon-edit">添加
                </el-button>
                <el-button class="filter-item" type="primary" :loading="downloadLoading" v-waves icon="el-icon-download"
                           @click="handleDownload">导出
                </el-button>
            </div>
        </div>

        <el-table :key='tableKey' :data="list" v-loading="listLoading" border fit highlight-current-row
                  style="width: 100%;">
            <yf-table-column align="center" label="ID">
                <template slot-scope="scope">
                    <span>{{ scope.row.lotteryGoods.id }}</span>
                </template>
            </yf-table-column>
            <yf-table-column align="center" label="活动">
                <template slot-scope="scope">
                    <span v-if="scope.row.lotteryAct">{{ scope.row.lotteryAct.name }}</span>
                </template>
            </yf-table-column>
            <yf-table-column align="center" label="奖品名称">
                <template slot-scope="scope">
                    <span v-if="scope.row.lotteryGoods">{{ scope.row.lotteryGoods.name }}</span>
                </template>
            </yf-table-column>
            <yf-table-column align="center" label="权重">
                <template slot-scope="scope">
                    <span v-if="scope.row.lotteryGoods">{{ scope.row.lotteryGoods.weight }}</span>
                </template>
            </yf-table-column>
            <yf-table-column align="center" label="多少次出一个">
                <template slot-scope="scope">
                    <span v-if="scope.row.lotteryGoods">{{ scope.row.lotteryGoods.pr }}</span>
                </template>
            </yf-table-column>
<!--            <yf-table-column align="center" label="内定中奖者">-->
<!--                <template slot-scope="scope">-->
<!--                    <span v-if="scope.row.lotteryGoods">{{ scope.row.lotteryGoods.code }}</span>-->
<!--                </template>-->
<!--            </yf-table-column>-->
<!--            <yf-table-column align="center" label="绑定奖品">-->
<!--                <template slot-scope="scope">-->
<!--                    <span v-if="scope.row.lotteryGoods">{{ scope.row.lotteryGoods.goodsName }}</span>-->
<!--                </template>-->
<!--            </yf-table-column>-->

<!--            <yf-table-column align="center" label="抵扣卷">-->
<!--                <template slot-scope="scope">-->
<!--                    <span v-if="scope.row.lotteryGoods">{{ scope.row.lotteryGoods.coupon }}</span>-->
<!--                </template>-->
<!--            </yf-table-column>-->

            <yf-table-column align="center" label="启用">
                <template slot-scope="scope">
                                                <span v-if="scope.row.lotteryGoods">

                         <el-tag :type="tagTypes[scope.row.lotteryGoods.status]"
                                 v-if="scope.row.lotteryGoods.status!=null">     {{
                             statusOptions[scope.row.lotteryGoods.status]
                           }}</el-tag>

                        </span>
                </template>
            </yf-table-column>

            <yf-table-column align="center" label="操作" width="230" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                    <el-button type="primary" v-if="canUpdate" size="mini" @click="handleUpdate(scope)">编辑</el-button>
                    <el-button v-if="canSave" size="mini" type="danger"
                               @click="handleDelete(scope)">删除
                    </el-button>
                </template>
            </yf-table-column>

        </el-table>

        <div class="pagination-container" style="margin-top: 20px">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :current-page="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit"
                           layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>

        <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
            <el-form :rules="rules" ref="dataForm" :model="temp" label-position="left" label-width="120px"
                     style='width: 450px; margin-left:50px;'>
                <el-form-item label="活动ID" prop="lotteryGoods.actId">
                  <el-select v-model="temp.lotteryGoods.actId" filterable placeholder="请选择">
                    <el-option
                        v-for="item in lotteryList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="奖品名称" prop="lotteryGoods.name">
                    <el-input v-model="temp.lotteryGoods.name"></el-input>
                </el-form-item>
                <el-form-item label="权重" prop="lotteryGoods.weight">
                    <el-input placeholder="0-1的小数" v-model="temp.lotteryGoods.weight"></el-input>
                </el-form-item>
                <el-form-item label="多少次出一个" prop="lotteryGoods.pr">
                    <el-input placeholder="0代表不限制" v-model="temp.lotteryGoods.pr"></el-input>
                </el-form-item>
<!--                <el-form-item label="内定中奖者" prop="lotteryGoods.code">-->
<!--                    <el-input v-model="temp.lotteryGoods.code"></el-input>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="绑定奖品" prop="lotteryGoods.goodsId">-->
<!--                    <el-select v-model="temp.lotteryGoods.goodsId" filterable placeholder="请选择">-->
<!--                        <el-option-->
<!--                                v-for="item in goodsList"-->
<!--                                :key="item.id"-->
<!--                                :label="item.name"-->
<!--                                :value="item.id">-->
<!--                        </el-option>-->
<!--                    </el-select>-->
<!--                </el-form-item>-->

<!--                <el-form-item label="抵扣卷" prop="lotteryGoods.coupon">-->
<!--                    <el-input v-model="temp.lotteryGoods.coupon"></el-input>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="排序" prop="lotteryGoods.idx">-->
<!--                    <el-select class="filter-item" v-model="temp.lotteryGoods.idx" placeholder="排序">-->
<!--                        <el-option v-for="(item,index) in  idxOptions" :key="item" :label="item"-->
<!--                                   :value="index">-->
<!--                        </el-option>-->
<!--                    </el-select>-->
<!--                </el-form-item>-->
                <el-form-item label="启用" prop="lotteryGoods.status">
                    <el-select class="filter-item" v-model="temp.lotteryGoods.status" placeholder="启用">
                        <el-option v-for="(item,index) in  statusOptions" :key="item" :label="item"
                                   :value="index">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="奖品图" prop="lotteryGoods.goodsImg">
                    <el-upload
                            ref="goodsImgUpload"
                            action="https://upload.qiniup.com"
                            :auto-upload="true"
                            list-type="picture-card"
                            :on-preview="handlePictureCardPreview"
                            :before-upload="handleUpload"
                            :file-list="goodsImgList"
                            :on-success="(response, file, fileList)=>handleImgUploadSuccess(goodsImgList,file)"
                            :data="qData"
                            :on-remove="(file, fileList)=>handleImgRemove(goodsImgList,file)">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>

                <el-dialog :visible.sync="dialogVisible" append-to-body>
                    <img width="100%" :src="dialogImageUrl" alt="">
                </el-dialog>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialogForm">取消</el-button>
                <el-button v-if="dialogStatus=='create'" type="primary" @click="createData">确认</el-button>
                <el-button v-else type="primary" @click="updateData">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<style type="stylus">
    .filter-container {
        /*padding-bottom: 20px;*/
    }

    .filter-item {
        margin-bottom: 10px;
    }

    .filter-item.input {
        /*line-height: 60px*/
        margin-right: 10px;
    }
</style>

<script>
    import {list, options, down, info, save, update, remove} from '@/api/lottery_goods'
    import waves from '@/directive/waves' // 水波纹指令
    import {downExcel} from '@/utils/down.js'

    import {getToken, domain} from '@/api/qiniu'
    import {listToStrs, strsToList} from '@/utils/imgUtil'

    import {mapGetters} from 'vuex'
    import {hasAuth} from '@/utils/auth'

    export default {
        name: 'test',
        directives: {
            waves
        },
        data() {
            return {
                tableKey: 0,
                list: null,
                goodsList: [],
                lotteryList: [],
                total: null,
                listLoading: true,
                listQuery: {
                    page: 1,
                    limit: 20,
                    order: 'lotteryGoods.id desc',
                    entity: {
                        lotteryGoods:
                            {
                                id: null,
                                actId: null,
                                name: null,
                                idx: null,
                                weight: null,
                                status: null,
                                pr: null,
                                goodsImg: null,
                                code: null,
                                goodsId: null,
                                goodsName: null,
                                coupon: null
                            },lotteryAct:{name:null}
                    }
                },

                idxOptions: ['1', '2', '3', '4', '5', '6', '7', '8'],
                statusOptions: ['未启用', '启用'],

                tagTypes: ['info', '', 'warning', 'danger', 'warning'],
                temp: {

                    lotteryGoods:
                        {
                            id: null,
                            actId: null,
                            name: null,
                            idx: null,
                            weight: null,
                            status: null,
                            pr: null,
                            goodsImg: null,
                            code: null,
                            goodsId: null,
                            coupon: null
                        }


                }
                ,
                dialogFormVisible: false,
                dialogStatus: '',
                textMap: {
                    update: '修改',
                    create: '新增'
                }
                ,
                // 存在图片
                dialogImageUrl: '',
                dialogVisible: false,
                goodsImgList: [],
                rules:
                    {
                        'lotteryGoods.actId': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'lotteryGoods.name': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'lotteryGoods.idx': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'blur'
                            }
                        ]
                        ,
                        'lotteryGoods.weight': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'lotteryGoods.status': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'blur'
                            }
                        ]
                        ,
                        'lotteryGoods.pr': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'lotteryGoods.goodsImg': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'lotteryGoods.code': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'lotteryGoods.goodsId': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'lotteryGoods.coupon': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                    }
                ,
                downloadLoading: false,
                qData:
                    {
                        token: '',
                        key: ''
                    }
            }
        },
        created() {
            this.getList()
            this.getOptions()
        },
        computed: {
            ...mapGetters([
                'perms'
            ]),
            canSave() {
                return hasAuth(this.perms, 'lottery:goods:save')
            },
            canDelete() {
                return hasAuth(this.perms, 'lottery:goods:delete')
            },
            canUpdate() {
                return hasAuth(this.perms, 'lottery:goods:update')
            },
            canList() {
                return hasAuth(this.perms, 'lottery:goods:list')
            }
        },
        methods: {
            getList() {
                this.listLoading = true
                list(this.listQuery).then(response => {
                    this.list = response.data.list
                    this.total = response.data.total
                    this.goodsList = response.extra.goodsList
                    this.lotteryList = response.extra.lotterys
                    this.listLoading = false
                })
            },
            getOptions() {
                options().then(res => {
                    this.idxOptions = res.data.idxOptions
                    this.statusOptions = res.data.statusOptions
                })
            },
            handleFilter() {
                this.listQuery.page = 1
                this.getList()
            },
            handleSizeChange(val) {
                this.listQuery.limit = val
                this.getList()
            },
            handleCurrentChange(val) {
                this.listQuery.page = val
                this.getList()
            },
            handleModifyStatus(row, status) {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                })
                row.status = status
            },
            beforeFormShow(row) {
                this.resetTemp(row) // 更新数据
                // 存在图片
                this.initQiniu()

                // 存在图片字段转换图片地址显示
                this.initImgUrl()
            },
            afterFormShow(row) {

            },
            beforeFormCommit() {
                this.initImgName()// 图片转换
            },
            resetTemp(row) {

                this.temp = {
                    lotteryGoods: {}
                }
                if (row) {
                    this.temp = Object.assign({}, row) // copy obj
                }

            },
            handleCreate() {
                this.beforeFormShow()
                this.dialogStatus = 'create'
                this.dialogFormVisible = true
                this.$nextTick(() => {
                    this.afterFormShow()
                    this.$refs['dataForm'].clearValidate()
                })
            },
            handleDelete(scope) {
                this.index = scope.$index
                // this.beforeFormShow(scope.row)
                // this.temp = Object.assign({}, row) // copy obj
                this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // this.$message({
                    //   type: 'success',
                    //   message: '删除成功!'
                    // })
                    this.deleteData()
                }).catch(() => {
                    this.$message({
                        type: 'error',
                        message: '删除失败'
                    })
                })
            },
            // 显示将图片名封装成可以展示状态集合
            initImgUrl() {
                this.goodsImgList = strsToList(this.temp.lotteryGoods.goodsImg, domain)
            },
            // 关闭显示窗口 重置图片地址 防止错乱
            resetImgUrl() {
                this.goodsImgList = []
            },
            // 上传或者更新的时候从图片链接中获取图片名字
            initImgName() {
                this.temp.lotteryGoods.goodsImg = listToStrs(this.goodsImgList)
            },
            createData() {
                this.$refs['dataForm'].validate((valid) => {
                        if (valid) {
                            this.beforeFormCommit()

                            save(this.temp).then(res => {
                                this.temp = res.data
                                this.list.unshift(this.temp)
                                this.closeDialogForm()
                                this.$notify({
                                    title: '成功',
                                    message: '创建成功',
                                    type: 'success',
                                    duration: 2000
                                })
                            })
                        }
                    }
                )
            },
            deleteData() {
                // const ids = [this.temp.lotteryGoods.id]
                const ids = [this.list[this.index].lotteryGoods.id]
                remove({ids: ids}).then(res => {
                    // 从当前队列中移除
                    this.list.splice(this.index, 1)
                    this.$notify({
                        title: '成功',
                        message: '删除成功',
                        type: 'success',
                        duration: 2000
                    })
                })
            },
            handleUpdate(scope) {
                this.beforeFormShow(scope.row)
                info(scope.row.lotteryGoods.id).then(res => {
                    this.temp = res.data
                    this.dialogStatus = 'update'
                    this.dialogFormVisible = true
                    this.$nextTick(() => {
                        this.$refs['dataForm'].clearValidate()
                    })
                })
            },
            updateData() {
                this.$refs['dataForm'].validate((valid) => {
                        if (valid) {
                            this.beforeFormCommit()
                            update(this.temp).then(() => {
                                // this.list.splice(this.index, 1, this.temp)
                                this.getList()
                                this.closeDialogForm()
                                this.$notify({
                                    title: '成功',
                                    message: '更新成功',
                                    type: 'success',
                                    duration: 2000
                                })
                            })
                        }
                    }
                )
            },
            closeDialogForm() {
                // 存在图片
                this.resetImgUrl()
                this.dialogFormVisible = false
            },
            handleDownload() {
                this.downloadLoading = true
                down(this.listQuery).then(res => {
                    downExcel(res)
                    this.downloadLoading = false
                    this.$notify({
                        title: '成功',
                        message: '下载成功',
                        type: 'success',
                        duration: 2000
                    })
                })
            },
            // formatJson(filterVal, jsonData) {
            //     return jsonData.map(v => filterVal.map(j => {
            //         return v[j]
            //     }
            // ))
            // },
            // 存在图片
            handleUpload(file) {
                this.qData.key = new Date().valueOf() + file.name
            },
            initQiniu() {
                // 获取七牛配置
                getToken().then(res => {
                    this.qData.token = res.data
                }).catch(error => {
                    console.log(error)
                })
            },
            handleImgUploadSuccess(imgList, file) {
                imgList.push({name: file.response.key, url: domain + file.response.key})
            },
            handleImgRemove(imgList, file) {
                for (var fn of imgList) {
                    if (fn.name === file.name) {
                        imgList.splice(imgList.indexOf(fn), 1)
                    }
                }
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url
                this.dialogVisible = true
            }
        }
    }
</script>
